// extracted by mini-css-extract-plugin
module.exports = {"sider_box":"sider_box-3LCMCWIN","sider":"sider-22IMDRP-","stock_box":"stock_box-2sZKXtCw clearfix","sider_list":"sider_list-XtzVNWg0"};